import NumberFormat from 'react-number-format';
import React from 'react';

export const VAT_RATE = 1.25;

const DEFAULT_DECIMAL_SCALE = 2;

const MoneyFormat = ({ value, decimalScale }) => (
  <NumberFormat
    displayType={'text'}
    fixedDecimalScale={true}
    decimalScale={decimalScale || decimalScale === 0 ? decimalScale : DEFAULT_DECIMAL_SCALE}
    thousandSeparator={true}
    value={value}
  />
);

export default MoneyFormat;